import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Employer } from 'model/model.employer';
import { AdminService } from '../../../services/admin';


@Component({
  selector: 'app-statistique-global-consultation',
  templateUrl: './statistique-global-consultation.component.html',
  styleUrls: ['./statistique-global-consultation.component.scss']
})
export class StatistiqueGlobalConsultationComponent implements OnInit {

  id:number;
  mode_rapport:number=1;
  employers : Array<Employer>=new Array<Employer>();
  listeMedecin : Array<Employer>=new Array<Employer>();
	date_debut : Date;
	date_fin : Date;
  employer : Employer=new Employer(null);
  title:string ="";
  loginuserCMSActuel: any;
  mode_admin: number;
  mode_recherche: number=1;
  listeatt_by_dr: any;
  
  constructor(public activatedRoute: ActivatedRoute,public adminService: AdminService) { 
   this.id = activatedRoute.snapshot.params['id'];
   this.loginuserCMSActuel = this.adminService.getLoginUseCMS();
   if(this.loginuserCMSActuel=="cms_daf"){
     this.mode_admin=1;
    }else{
      this.mode_admin=11;
    }
  }

   ngOnInit() {

    if(this.id==1 ){
       this.title = "Statistique de consultation par médecin"
    }else if(this.id==2 ){
      this.title = "Statistique de consultation par site"
    }else if(this.id==3 ){
      this.title = "Statistique de consultation"
    }

    this.getListStatistiqueMedecin();
    this.getListMedecin();
  }




  onChange(deviceValue) {
    console.log(deviceValue);    
    this.mode_recherche = 2;
    this.adminService.getListeAttenteParMedParMLocalite(deviceValue)
    .subscribe(data => {
      this.listeatt_by_dr = data;
    }, err => {
      console.log(err);
    })
   }

  getListStatistiqueMedecin(){
  	this.adminService.getStatistiqueConsultationParMedecin(this.employer).subscribe(data=>{
      this.employers=data;
      console.log("ireto izahay tompoko"+data)
  	},err=>{

  	});
  }


  getListMedecin(){
    this.adminService.getMedecin("",0,0).subscribe(data=>{
        this.listeMedecin=data;
    },err=>{

    });
  }
}
